import { environment as devEnv } from './environment';

export const environment = {
  ...devEnv,
  production: false,
  msalConfig: {
    auth: {
      clientId: 'd31daf32-1b0e-48a0-a9db-6bb649301bfc',
      authority: 'https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8',
      scopes: ['User.Read'],
    },
  },
  apiConfig: {
    graph_api: {
      scopes: ['User.Read'],
      uri: 'https://graph.microsoft.com/v1.0/me',
    },
    articleplan_api: {
      scopes: ['28b4a699-7c82-4263-b0ad-7b89040df70a/ArticlePlan.API.ReadWrite'],
      uri: 'https://tdarticleplan-app-test.nicefield-adcfe335.swedencentral.azurecontainerapps.io',
    },
  },
  timeouts: {
    toastMs: 5000,
  },
  externalApps: {
    assortmentCanvas: 'https://assortmentcanvas-sit.azurewebsites.net/',
    assortmentOverview: 'https://hm-assortmentoverviewui-sit.azurewebsites.net/',
    productPlan: 'https://sit.productplan.hm.com/',
    assortmentSupportLearning:
      'https://hmgroup.atlassian.net/wiki/spaces/spbads/pages/3698491436/App+Menu+NEW',
  },
};
